<template>
  <div>
    <apexchart
        type="bar"
        height="220"
        :options="chartOptions"
        :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import dayjs from 'dayjs'

export default {
  props: ['chart_data'],
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      series: [
        {
          name: 'Profit',
          data: this.chart_data.pnl
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 220,
          toolbar: { show: false },
          parentHeightOffset: 0
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            columnWidth: '60%',
            colors: {
              ranges: [{
                from: -Infinity,
                to: 0,
                color: '#FF4560'
              }, {
                from: 0,
                to: Infinity,
                color: '#00E396'
              }]
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          categories: this.chart_data.dates,
          labels: {
            formatter: (val) => dayjs(val).format('DD/MM'),
            style: {
              colors: '#9e9e9e',
              fontSize: '12px'
            }
          },
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: {
          labels: {
            formatter: (val) => Math.round(val),
            style: {
              colors: '#9e9e9e',
              fontSize: '12px'
            }
          }
        },
        grid: {
          borderColor: '#ebebeb',
          yaxis: { lines: { show: true } }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return `${val.toFixed(2)} USD`
            }
          }
        }
      }
    }
  },
  methods: {
    getTotalPnl() {
      return this.chart_data.pnl.reduce((acc, value) => acc + value, 0)
    }
  }
}
</script>
